import type { SpatialTreeNode } from "../../../../types/bim-viewer.types";

const storey = (level: number, classes: { name: string; count: number }[]): SpatialTreeNode => ({
  key: `storey-${level}`,
  title: level === 0 ? "Ground Floor" : level < 0 ? `Basement ${Math.abs(level)}` : `Level ${level}`,
  type: "storey",
  elementCount: classes.reduce((acc, c) => acc + c.count, 0),
  children: classes.map((c) => ({
    key: `storey-${level}-${c.name}`,
    title: c.name,
    type: "class",
    elementCount: c.count,
    isLeaf: true,
  })),
});

export const mockSpatialTree: SpatialTreeNode[] = [
  {
    key: "site-1",
    title: "Site — Tower A Plot",
    type: "site",
    elementCount: 15240,
    children: [
      {
        key: "building-1",
        title: "Tower A",
        type: "building",
        elementCount: 15240,
        children: [
          storey(-1, [
            { name: "IfcWall", count: 120 },
            { name: "IfcSlab", count: 14 },
            { name: "IfcColumn", count: 38 },
            { name: "IfcDoor", count: 22 },
          ]),
          storey(0, [
            { name: "IfcWall", count: 180 },
            { name: "IfcSlab", count: 18 },
            { name: "IfcColumn", count: 44 },
            { name: "IfcDoor", count: 36 },
            { name: "IfcWindow", count: 64 },
            { name: "IfcCurtainWall", count: 12 },
          ]),
          ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((lvl) =>
            storey(lvl, [
              { name: "IfcWall", count: 140 + lvl * 4 },
              { name: "IfcSlab", count: 16 },
              { name: "IfcColumn", count: 40 },
              { name: "IfcDoor", count: 28 },
              { name: "IfcWindow", count: 72 },
              { name: "IfcBeam", count: 60 },
            ])
          ),
          storey(11, [
            { name: "IfcWall", count: 80 },
            { name: "IfcSlab", count: 8 },
            { name: "IfcRoof", count: 6 },
            { name: "IfcRailing", count: 24 },
          ]),
        ],
      },
    ],
  },
];

export const mockClassificationSummary = [
  { ifcClass: "IfcWall", count: 1844, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcSlab", count: 192, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcColumn", count: 478, discipline: "STRUCTURAL" },
  { ifcClass: "IfcBeam", count: 612, discipline: "STRUCTURAL" },
  { ifcClass: "IfcDoor", count: 318, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcWindow", count: 736, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcCurtainWall", count: 12, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcStair", count: 28, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcRailing", count: 156, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcRoof", count: 6, discipline: "ARCHITECTURAL" },
  { ifcClass: "IfcPipeSegment", count: 2840, discipline: "MEP_MECHANICAL" },
  { ifcClass: "IfcDuctSegment", count: 1620, discipline: "MEP_MECHANICAL" },
  { ifcClass: "IfcCableCarrierSegment", count: 980, discipline: "MEP_ELECTRICAL" },
  { ifcClass: "IfcLightFixture", count: 1840, discipline: "MEP_ELECTRICAL" },
  { ifcClass: "IfcFlowFitting", count: 1240, discipline: "MEP_MECHANICAL" },
  { ifcClass: "IfcSanitaryTerminal", count: 184, discipline: "MEP_PLUMBING" },
];
